export default {
  PROPERTY_MAP: "companies/:company_id/property-map/",
};
